<template>
  <section>
    <el-card shadow="never" size="small">
      <div slot="header" class="clearfix">
        <span>小程序基本配置</span>
        <el-button
          style="float: right"
          type="primary"
          @click.native="infoSubmit"
          :loading="loading"
          >{{ $t("save") }}</el-button
        >
      </div>
      <el-form
        :model="editForm"
        label-width="250px"
        ref="editForm"
        size="small"
      >
        <el-form-item
          label="小程序分享描述"
          prop="shareTitle"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '小程序分享描述',
          }"
        >
          <el-input v-model="editForm.shareTitle"></el-input>
        </el-form-item>
        <el-form-item label="关注文章页URL" prop="concernUrl">
          <el-input v-model="editForm.concernUrl"></el-input>
        </el-form-item>
        <el-form-item label="地区验证">
          <el-switch v-model="editForm.RegionVerify"></el-switch>
        </el-form-item>
        <el-form-item label="订单列表通告文字" prop="orderListTitle">
          <el-input v-model="editForm.orderListTitle"></el-input>
        </el-form-item>
        <el-form-item
          label="拼单邀请文字{sname}代表商户名称"
          prop="shareInvite"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '拼单邀请文字',
          }"
        >
          <el-input v-model="editForm.shareInvite"></el-input>
        </el-form-item>
        <el-form-item
          label="订单默认加载天数"
          prop="OrderDateLoadDays"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '订单默认加载天数',
          }"
        >
          <el-input
            v-model.number="editForm.OrderDateLoadDays"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="首页飘窗广告图" prop="adPath">
          <div class="upload-img-form">
            <el-upload
              class="upload-img"
              :auto-upload="false"
              action="xxx"
              list-type="picture"
              :show-file-list="false"
              :on-change="uphandleChange"
              :style="{
                backgroundImage:
                  'url(' + baseCoverUrl + editForm.EditadPath + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
              }"
              accept="image/png, image/gif, image/jpg, image/jpeg"
            >
              <i
                v-show="!editForm.EditadPath"
                class="el-icon-upload avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditadPath"
                class="el-icon-refresh avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditadPath"
                slot="tip"
                class="el-icon-delete-solid delete-icon"
                @click="deleteImg"
              ></i>
              <div
                v-show="!editForm.EditadPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                {{ $t("uploadImgLabel") }}
              </div>
              <div
                v-show="editForm.EditadPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                {{ $t("uploadChoose") }}
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="首页飘窗点击跳转URL" prop="adUrl">
          <el-input v-model="editForm.adUrl"></el-input>
        </el-form-item>
        <el-form-item label="首页左广告图" prop="adwareLeftPath">
          <div class="upload-img-form">
            <el-upload
              class="upload-img"
              :auto-upload="false"
              action="xxx"
              list-type="picture"
              :show-file-list="false"
              :on-change="uphandleAdLeftChange"
              :style="{
                backgroundImage:
                  'url(' + baseLeftCoverUrl + editForm.EditadwareLeftPath + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
              }"
              accept="image/png, image/gif, image/jpg, image/jpeg"
            >
              <i
                v-show="!editForm.EditadwareLeftPath"
                class="el-icon-upload avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditadwareLeftPath"
                class="el-icon-refresh avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditadwareLeftPath"
                slot="tip"
                class="el-icon-delete-solid delete-icon"
                @click="deleteAdLeftImg"
              ></i>
              <div
                v-show="!editForm.EditadwareLeftPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                {{ $t("uploadImgLabel") }}
              </div>
              <div
                v-show="editForm.EditadwareLeftPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                {{ $t("uploadChoose") }}
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item
          label="左广告模式"
          prop="adwareLeftMode"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + '左广告模式',
          }"
        >
          <el-select
            v-model.number="editForm.adwareLeftMode"
            placeholder="请选模式"
            prop="adwareLeftMode"
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页左广告URL" prop="adUrl">
          <el-input v-model="editForm.adwareLeftUrl"></el-input>
        </el-form-item>
        <el-form-item label="首页右广告图" prop="adwareRightPath">
          <div class="upload-img-form">
            <el-upload
              class="upload-img"
              :auto-upload="false"
              action="xxx"
              list-type="picture"
              :show-file-list="false"
              :on-change="uphandleAdRightChange"
              :style="{
                backgroundImage:
                  'url(' +
                  baseRightCoverUrl +
                  editForm.EditadwareRightPath +
                  ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
              }"
              accept="image/png, image/gif, image/jpg, image/jpeg"
            >
              <i
                v-show="!editForm.EditadwareRightPath"
                class="el-icon-upload avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditadwareRightPath"
                class="el-icon-refresh avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditadwareRightPath"
                slot="tip"
                class="el-icon-delete-solid delete-icon"
                @click="deleteAdRightImg"
              ></i>
              <div
                v-show="!editForm.EditadwareRightPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                {{ $t("uploadImgLabel") }}
              </div>
              <div
                v-show="editForm.EditadwareRightPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                {{ $t("uploadChoose") }}
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item
          label="右广告模式"
          prop="adwareRightMode"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + '右广告模式',
          }"
        >
          <el-select
            v-model.number="editForm.adwareRightMode"
            placeholder="请选模式"
            prop="adwareRightMode"
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页右广告URL" prop="adUrl">
          <el-input v-model="editForm.adwareRightUrl"></el-input>
        </el-form-item>
        <el-form-item label="拼单说明">
          <vue-ueditor-wrap
            v-model="editForm.tourDiyExplain"
          ></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
    </el-card>
  </section>
</template>
<script>
import VueUeditorWrap from "@/components/vue-ueditor-wrap";
import util from "util/date";
import { base, getMiniConifg, editMiniConifg } from "@/api/api";

export default {
  components: { VueUeditorWrap },
  data() {
    return {
      modelList: [
        { label: "纯图片", value: 1 },
        { label: "小程序URL", value: 2 },
        { label: "网页URL", value: 3 },
      ],
      baseCoverUrl: base + "/FileUpload/SystemImage/a0/",
      baseLeftCoverUrl: base + "/FileUpload/SystemImage/a0/",
      baseRightCoverUrl: base + "/FileUpload/SystemImage/a0/",
      loading: false,
      editForm: {},
    };
  },
  methods: {
    deleteImg() {
      this.$confirm("您确定删除吗？", this.$t("prompt"), {})
        .then(() => {
          this.baseCoverUrl = "";
          this.editForm.EditadPath = "";
          this.editForm.adPathFile = "";
          this.editForm.adPath = "";
        })
        .catch(() => {});
    },
    deleteAdLeftImg() {
      this.$confirm("您确定删除吗？", this.$t("prompt"), {})
        .then(() => {
          this.baseLeftCoverUrl = "";
          this.editForm.EditadwareLeftPath = "";
          this.editForm.adwareLeftFile = "";
          this.editForm.adwareLeftPath = "";
        })
        .catch(() => {});
    },
    deleteAdRightImg() {
      this.$confirm("您确定删除吗？", this.$t("prompt"), {})
        .then(() => {
          this.baseRightCoverUrl = "";
          this.editForm.EditadwareRightPath = "";
          this.editForm.adwareRightFile = "";
          this.editForm.adwareRightPath = "";
        })
        .catch(() => {});
    },
    // 图片预览
    uphandleChange(file) {
      this.baseCoverUrl = "";
      this.editForm.EditadPath = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.adPathFile = res;
      });
    },
    uphandleAdLeftChange(file) {
      this.baseLeftCoverUrl = "";
      this.editForm.EditadwareLeftPath = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.adwareLeftFile = res;
      });
    },
    uphandleAdRightChange(file) {
      this.baseRightCoverUrl = "";
      this.editForm.EditadwareRightPath = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.adwareRightFile = res;
      });
    },
    //编辑
    infoSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.loading = true;
              let para = Object.assign({}, this.editForm);
              editMiniConifg(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.loading = false;
                  return;
                }
                if (res.data.success) {
                  this.loading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.editFormVisible = false;
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    getMiniConifg().then((res) => {
      this.editForm = Object.assign({}, this.clone(res.data.response));
      this.editForm.EditadPath = this.editForm.adPath;
      this.editForm.adPathFile = "";
      this.editForm.EditadwareLeftPath = this.editForm.adwareLeftPath;
      this.editForm.adwareLeftFile = "";
      this.editForm.EditadwareRightPath = this.editForm.adwareRightPath;
      this.editForm.adwareRightFile = "";
    });
  },
};
</script>